var _path;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
var SvgIconBell48Filled = function SvgIconBell48Filled(props) {
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: "current",
    height: "current",
    viewBox: "0 0 48 48",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg"
  }, props), _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M37 30.45h-2.3v-9.3a10.71 10.71 0 0 0-9-10.55V8.15h-3.4v2.45a10.71 10.71 0 0 0-9 10.55v9.3H11v3.4h8.3v1.3a4.71 4.71 0 0 0 4.7 4.7 4.71 4.71 0 0 0 4.7-4.7v-1.3H37v-3.4Z",
    fill: "current"
  })));
};
export default SvgIconBell48Filled;